export default function Topbar({ tab, view, viewTitle, onBreadcrumbClick, onScanDrive, onUploadReceipts, onNewInvoice, onDownloadAll, onDeleteAll, deletingAll }) {
  const isLedgerView = view === 'sales-ledger' || view === 'purchase-ledger';
  const rootLabel = view === 'sales-ledger' ? 'Sales Ledger'
    : view === 'purchase-ledger' ? 'Purchase Ledger'
      : (tab === 'sale' ? 'Sales' : 'Purchases');
  const isRootView = view === 'list' || isLedgerView;

  return (
    <div className="topbar no-print">
      <div className="breadcrumb">
        <button className="crumb" onClick={isRootView ? undefined : onBreadcrumbClick} style={isRootView ? { cursor: 'default' } : undefined}>
          {rootLabel}
        </button>
        {!isRootView && (
          <>
            <span className="crumb-sep">›</span>
            <span className="crumb-active">{viewTitle}</span>
          </>
        )}
      </div>
      {view === 'list' && (
        <div className="topbar-actions">
          {/* <button className="btn btn-ghost btn-sm" onClick={onScanDrive}>📁 Scan Drive</button>
          <button className="btn btn-outline" onClick={onUploadReceipts}>📷 Upload Receipts</button> */}
          <button className="btn btn-outline" onClick={onDownloadAll}>📥 Download All (ZIP)</button>
          <button className="btn btn-outline" onClick={onDeleteAll} disabled={deletingAll} style={{ color: 'var(--danger, #d9534f)', opacity: deletingAll ? 0.6 : 1 }}>
            {deletingAll ? '⏳ Deleting...' : '🗑 Delete All'}
          </button>
          <button className="btn btn-primary" onClick={onNewInvoice}>+ New Invoice</button>
        </div>
      )}
    </div>
  );
}